export default {
    computed: {
        paginationLayout() {
            return this.mdLayout ? 'total, ->, jumper, prev, next' : 'total, sizes, ->, jumper, prev, pager, next';
        },
    },
};
